import { baseRequestWithHeaders, rootRequestWithHeaders } from './base-request';

export const getAllCenters = (params) => {
    const url = `practice/network-center/all-centers`;
    const method = 'get';
    return baseRequestWithHeaders(url, method, params, null);
};
